module.exports = __webpack_public_path__ + "static/28-376ec190d866c3cc793cf7138f143e6a.png";